import { ValueProvider } from '@angular/cli';
import {IOption} from 'ng-select';

interface SelectData {
    project_nature: IOption[];
    project_construction: IOption[];
    project_state: IOption[];
}

const SelectData: SelectData = {
    // 项目投资性质
    project_nature: [{
        label: '国资',
        value: '1'
    }, {
        label: '民资',
        value: '2'
    }, {
        label: '外资',
        value: '3'
    }, {
        label: '合资',
        value: '4'
    }, {
        label: '其他',
        value: '5'
    }],
    // 项目结构形式
    project_construction: [{
        label: '框架结构',
        value: '1'
    }, {
        label: '钢结构',
        value: '2'
    }, {
        label: '钢混结构',
        value: '3'
    }, {
        label: '其他',
        value: '4'
    }],
    // 项目状态
    project_state: [{
        label: '购买土地',
        value: '1'
    }, {
        label: '方案设计',
        value: '2'
    }, {
        label: '项目立项',
        value: '3'
    }, {
        label: '四个评价',
        value: '4'
    }, {
        label: '土地规划',
        value: '5'
    }, {
        label: '工程规划',
        value: '6'
    }, {
        label: '工程招标',
        value: '7'
    }, {
        label: '施工许可',
        value: '8'
    }, {
        label: '其它',
        value: '9'
    }]
};

export const SelectDataProvider: ValueProvider = {
    provide: 'SelectData',
    useValue: SelectData
};



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/lib/provider/select_data.ts